import {
    ColoursObj,
    Icon,
    MobileInfoDialog,
    TDialogStore,
    Typography,
    useDialogStore,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'

export const ItinVersionRowSummary = () => {
    const { selectedItinerary, getEventInfoV2 } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItinerary: s.selectedItinerary,
                getEventInfoV2: s.getEventInfoV2,
            }
        })
    )
    const { replaceDialog, clearDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({
            clearDialog: s.clearDialog,
            replaceDialog: s.replaceDialog,
        }))
    )

    function getItinVersion() {
        let tmpLabel = ''
        if (selectedItinerary && selectedItinerary.version) {
            tmpLabel += selectedItinerary.version
        }
        return tmpLabel
    }

    function getUpdatedAtTime() {
        let tmpLabel = ''
        try {
            if (selectedItinerary && selectedItinerary.updatedAt) {
                const tmpEventrDate = DateTime.fromFormat(
                    selectedItinerary.updatedAt,
                    'yyyy-MM-dd hh:mm:ss'
                )
                if (tmpEventrDate.isValid) {
                    tmpLabel +=
                        tmpEventrDate
                            .setLocale(navigator.language)
                            .toLocaleString(DateTime.DATETIME_MED) + ' GMT'
                }
            }
        } catch {
            return ''
        }

        return tmpLabel
    }

    function getDialogMessage() {
        try {
            const itinTitle = getEventInfoV2()?.data?.title || 'Unknown Title'
            return (
                itinTitle +
                i18n.t('header.itinVersionParaStart') +
                getItinVersion() +
                i18n.t('header.itinVersionParaEnd') +
                getUpdatedAtTime()
            )
        } catch {
            return 'Something went wrong. sorry'
        }
    }

    return (
        <Box display={'grid'} gridTemplateColumns={'1fr auto'} gap={'8px'}>
            {/* <Icon name="Visible" iconColour={ColoursObj.coreBrights.tertiary} /> */}
            <Typography
                onClick={() => [
                    replaceDialog({
                        node: (
                            <MobileInfoDialog
                                text={getDialogMessage()}
                                onClose={() => {
                                    clearDialog()
                                }}
                            />
                        ),
                        backdropClosable: true,
                    }),
                ]}
            >
                {/* {i18n.t('header.itinVersion') + getItinVersion()} */}
                {'Updated ' + getUpdatedAtTime()}
            </Typography>
            <Icon
                name="Info"
                iconColour={ColoursObj.core.secondary}
                onClick={() => {
                    replaceDialog({
                        node: (
                            <MobileInfoDialog
                                text={getDialogMessage()}
                                onClose={() => {
                                    clearDialog()
                                }}
                            />
                        ),
                        backdropClosable: true,
                    })
                }}
            />
        </Box>
    )
}
